import { CountryFlag } from '@/components/country-flag';
import { Text } from '@/components/text';
import { LocationModel } from '@/lib/models/location/types';
import { getPreferredIdentifier } from '@/utils/helpers';
import { getLocationName } from '@/utils/locations';
import { tv } from '@/utils/styles';

export interface EmissionsSegmentDetailsLocationProps {
  location?: LocationModel;
}

const EmissionsSegmentDetailsLocation = ({ location }: EmissionsSegmentDetailsLocationProps) => {
  const { text, base, identifierStyles } = styles();

  if (!location) {
    return (
      <div className={base()}>
        <Text variant="secondary" className={text()}>
          Unknown/Invalid location
        </Text>
      </div>
    );
  }
  const identifier = getPreferredIdentifier(location.identifiers)?.value;
  const locationName = getLocationName(location);

  return (
    <div className={base()}>
      {location.countryCode && <CountryFlag countryCode={location.countryCode} className="mt-1 h-3" />}
      <Text variant="secondary" className={text()}>
        <b>{locationName}</b> {identifier ? <span className={identifierStyles()}>({identifier})</span> : ''}
      </Text>
    </div>
  );
};

const styles = tv({
  slots: {
    base: 'flex items-start justify-start gap-2',
    text: 'mb-0 truncate',
    identifierStyles: 'text-grey-500',
  },
});

export { EmissionsSegmentDetailsLocation };
